export default __webpack_public_path__ + "static/media/author-2.1fd53547.png";